<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon"  [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faRunning"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.executor' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'validator.toolHeaderLine1' | translate}}<br>
          {{'validator.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="entityName && generateMindMap()">
                  <fa-icon class="fas fa-lg" [icon]="faSitemap" title="mindmap"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" (click)="entityName && openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTE">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
        <!-- <table class="dropGroupBtn">
          <tr>
            <td class="iconGroupHeight">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#jiraBugCreateModel">
                  <fa-icon class="fas" [icon]="faInfo"></fa-icon>
                </a>
              </span>
            </td>
            <td>
        
            </td>
          </tr>
          <tr class="bg-color-black">
            <td class="height25px">
              <span type="button" aria-disabled="true">
                <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td>
              <span data-toggle="modal" data-target="#jiraBugList" (click)="loadBugList()">
                <fa-icon class="fas" [icon]="faJira"></fa-icon>
              </span>
            </td>
          </tr>
        </table> -->
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="test-designer tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="row full-width p-0">
        <div class="col-sm-2 col-xs-3 btn-padding">
          <div class="row strict radio-button">
            <div class="dropdown">
              <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                type="button" data-toggle="dropdown">
                <div class="row strict">
                  <div class="col-xs-10">
                    <span *ngIf="selectedModule!=''">{{selectedModule.mName}}
                    </span>
                    <span *ngIf="selectedModule==''">{{'deepDive.chooseEUT' | translate }}</span>
                  </div>
                  <div class="col-xs-1 col-xs-offset-1 pull-right ">
                    <span class="caret"></span>
                  </div>
                </div>
              </button>
              <ul class="dropdown-menu deepDriveEntityDropdown">
                <li class="row strict" *ngFor="let module of modelData.modules">
                  <div class="col-xs-11 col-xs-offset-1  dropdown-item cursorPointer" (click)="selectModule(module)">
                    {{module.mName}}
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
        <div class="col-sm-7 col-xs-9 btn-padding ">
          <div class="dropdown">
            <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown">
              <div class="row strict" *ngIf="entityExists() == true">
                <div class="col-xs-10 span-on-button ">
                  {{entityName ||"deepDive.chooseEntityButton" | translate }}
                </div>
                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>
              <!-- <div *ngIf="entityExists(eutTypes[index]) == false">
                <strong>No
                  {{ getEntityType( eutTypes[index]) | lowercase }}
                  defined.</strong>
              </div> -->
            </button>
            <ul class="dropdown-menu fit-size">
              <li *ngIf="entityExists() == false">
                <div class="alert alert-warning cursorArrow">
                  <strong>No
                    entities
                    defined.</strong>
                </div>
              </li>
              <div class="row" *ngIf="entityExists() == true">
                <div class="col-xs-12">
                  <div class="input-group input-group-sm">
                    <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                      [placeholder]="'entities.searchEntity' | translate " ngDefaultControl />
                    <span class="input-group-addon " id="basic-addon2">
                      <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                    </span>
                  </div>
                </div>
              </div>
              <li
                *ngFor="let eut of modelData.listOfEUTs|moduleEntityListFilter:selectedModule:filterTypeList:searchText"
                (click)="loadEntityDetails(eut)">
                <a class="dropdown-item">({{getScenarioCountByeutID(eut)}}) {{ eut.eName }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-3 col-xs-12 col-sm-offset-0 btn-padding">
          <div class="row strict">
            <div class="col-xs-6 space-separable">
              <input type="text" class="form-control input-sm paddingtop3px paddingbottom3px" [(ngModel)]="build"
                (blur)="selectBuild(build)" [placeholder]="'validator.buildNo' | translate" ngDefaultControl />
            </div>
            <div class="col-xs-6 space-separable ">
              <div class="dropdown">
                <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                  type="button" data-toggle="dropdown">
                  <div class="row strict">
                    <div class="col-xs-10 text-flow">
                      {{ selectedEnvironment || 'validator.envButton' | translate }}
                    </div>
                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>

                <ul class="dropdown-menu dropdown-menu-right">
                  <li *ngIf="modelData.envMap.length <= 0">
                    <div class="alert alert-warning cursorArrow">
                      <strong>{{ 'validator.emptyEnv' | translate }}</strong>
                    </div>
                  </li>
                  <li class="row strict" (click)="chooseEnvironment(en.name)" *ngFor="let en of envMapArrayList">
                    <div class="col-xs-11 col-xs-offset-1 dropdown-item cursorPointer" title={{en.value}}>
                      {{ en.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row strict">
        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab" id="validatorActiveTab"
              (click)="createActivity('Exsc');changeCurrentView('scenarios');"
              ng-attr-data-target="#validatorScenariosTab">{{'validator.scenariosTab' | translate }}</a>
          </li>
          <li (click)="quillNoteReload();createActivity('Exde');changeCurrentView('design')">
            <a data-toggle="tab" ng-attr-data-target="#validatorDesignCasesTab">{{'validator.designNoteTab' | translate
              }}</a>
          </li>
          <li (click)="createActivity('Exsp');changeCurrentView('specs');">
            <a data-toggle="tab" ng-attr-data-target="#validatorSpecsTab">{{'validator.specsTab' | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content test-designer-nav-tab-content-height card">

        <div ng-attr-id="validatorScenariosTab" *ngIf="currentView == 'scenarios'"
          class="tab-pane fade in active h-100">

          <div class="row strict h-100 card bg-white">
            <div class="row strict h-100">
              <table class="table table-bordered ui-sort-table env1 bg-color-black h-100 mb-0 p-0 exScenatioTable"
                id="validatorScenTable">
                <thead class="">
                  <tr class="row strict border-bottom1px menuItemsClrWhite">
                    <th class="col-xs-2 col-sm-1 border-right1px">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button text-align-center">
                              Level
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                          <li class="row padding-vertical" *ngFor="let level of config.levels">
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly cursorPointer"
                                  (click)="addToLevelFilter(level,$event.target.checked)" type="checkbox">
                              </div>
                            </div>
                            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                              {{level}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th class="col-sm-1 col-xs-2 border-right1px">
                      <!-- <center>Test type</center> -->
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button text-align-center">
                              Test
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-200">
                          <li class="row padding-vertical" *ngFor="let a of testTypes">
                            <!-- |filter:{'eType':selectedEUT} -->
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly cursorPointer"
                                  (click)="addToAttributeFilter(a.symbol,$event.target.checked);"
                                  [checked]="isCheckedAttr(a.symbol)" type="checkbox">
                              </div>
                            </div>
                            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                              {{a.name+" ("+a.symbol+")"}}
                            </div>
                          </li>

                          <li class="row padding-vertical" *ngFor="let a of config.listOfAttributesUpdated">
                            <!-- |filter:{'eType':selectedEUT} -->
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly cursorPointer"
                                  (click)="addToAttributeFilter(a.symbol,$event.target.checked)" type="checkbox">
                              </div>
                            </div>
                            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                              {{a.name+" ("+a.symbol+")"}}
                            </div>
                          </li>
                        </ul>
                      </div>

                    </th>
                    <th class="col-xs-2 col-sm-1 border-left1px">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button text-align-center">
                              Type
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                          <li class="row padding-vertical" *ngFor="let type of scenarioTypes">
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly cursorPointer"
                                  (click)="addToCrFilter(type,$event.target.checked)" type="checkbox">
                              </div>
                            </div>
                            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                              {{type}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </th>

                    <th class="col-xs-4 col-sm-7 border-left1px cursorArrow">
                      {{ 'testDesigner.scenarioColumnHeader' | translate }}
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                        (click)="scenarioAddReset()"></fa-icon>&nbsp;
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash" title="delete"
                        (click)="deleteScenarioModal(newscenariodesc)"></fa-icon>&nbsp;
                      <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                          title="add" *ngIf="!editScenario.scenID"
                          (click)="CreateScenario(newscenariodesc)"></fa-icon> -->
                      <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                        (click)="CreateScenario(newscenariodesc)"></fa-icon>
                    </th>
                    <th class="col-xs-2 col-sm-1 border-left1px text-align-center cursorArrow">
                      {{ 'validator.executedHeading' | translate }}
                    </th>
                    <th class=" col-xs-2 col-sm-1 border-left1px text-align-center cursorArrow">
                      {{ 'validator.outcomeHeading' | translate }}
                    </th>
                    <!-- <th class=" col-xs-2 col-sm-1 border-left1px">
                      {{ 'validator.jiraHeading' | translate }}
                    </th> -->
                  </tr>
                  <tr class="row strict border-bottom1px background-black" auto-crud>
                    <td class="col-sm-1 col-xs-3 no-padding">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle scenario-button-height"
                          type="button" data-toggle="dropdown">

                          <div class="row strict">
                            <div class="col-xs-12 span-on-button">
                              <span *ngIf="newscenariolevel!=''">{{newscenariolevel}}
                              </span>
                              <span *ngIf="newscenariolevel==''">Level</span>
                            </div>
                            <div class="col-xs-1 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                          <li class="row strict" *ngFor="let level of config.levels" (click)="selectLevel(level)">
                            <div class="col-xs-12 col-xs-offset-1  dropdown-item cursorPointer">
                              {{level}}
                            </div>
                          </li>

                        </ul>
                      </div>
                    </td>
                    <td class="col-sm-2 col-xs-3 no-padding">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle scenario-button-height"
                          type="button" (click)="updateTestTypeStatus()" data-toggle="dropdown">

                          <div class="row strict">
                            <div class="col-xs-10 span-on-button">
                              <span *ngIf="newscenarioattr!=''">{{selectedTest.symbol}}
                              </span>
                              <span *ngIf="newscenarioattr==''">{{'testDesigner.chooseTest' | translate }}</span>
                            </div>
                            <div class="col-xs-1 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu menuItemsClrBlack">

                          <!-- <li class="row strict" *ngFor="let a of testTypes" (click)="selectTest(a)">
                            <div class="col-xs-11 col-xs-offset-1  dropdown-item">

                              {{a.name+" ("+a.symbol+")"}}
                            </div>
                          </li> -->

                          <li class="row strict" *ngFor="let Attr of scenarioStatusTestTypes"
                            (click)="selectTest(Attr)">
                            <div class="col-xs-11 col-xs-offset-1  dropdown-item cursorPointer">

                              <fa-icon class="fas" title="Not specified" *ngIf="!Attr.satisfy"
                                [icon]="faCircle"></fa-icon>
                              <fa-icon class="fas icon-black" title="Covered"
                                *ngIf="(Attr.satisfy == true && Attr.stated == true)" [icon]="faCheckCircle"></fa-icon>
                              <fa-icon class="fas icon-black" title="Not covered"
                                *ngIf="(Attr.satisfy == true && Attr.stated == false)"
                                [icon]="faTimesCircle"></fa-icon>&nbsp;&nbsp;{{Attr.name}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td class="col-sm-1 col-xs-2 no-padding">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle scenario-button-height"
                          type="button" data-toggle="dropdown">

                          <div class="row strict">
                            <div class="col-xs-12 span-on-button">
                              <span *ngIf="newscenariocr!=''">{{newscenariocr}}
                              </span>
                              <span *ngIf="newscenariocr==''">Type</span>
                            </div>
                            <div class="col-xs-1 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                          <li class="row strict" *ngFor="let type of scenarioTypes" (click)="selectType(type)">
                            <div class="col-xs-12 col-xs-offset-1  dropdown-item cursorPointer">
                              {{type}}
                            </div>
                          </li>

                        </ul>
                      </div>
                    </td>

                    <td class="col-xs-5 col-sm-8">
                      <input *ngIf="editScenario.scenID != ''"
                        class="form-control transparent scenario-input-field menuItemsClrBlack" rows="1"
                        [placeholder]="'validator.scenarioModify'|translate" autosize="true" id="validaotrScenTextarea"
                        [(ngModel)]="newscenariodesc" (keyup.enter)="CreateScenario(newscenariodesc)"
                        style="background-color : lightyellow !important;" ngDefaultControl>

                      <input *ngIf="editScenario.scenID == ''"
                        class="form-control transparent scenario-input-field menuItemsClrBlack" rows="1"
                        [placeholder]="'validator.scenarioAdd'|translate" autosize="true" id="validaotrScenTextarea"
                        [(ngModel)]="newscenariodesc" (keyup.enter)="CreateScenario(newscenariodesc)"
                        style="background-color : lightyellow !important;" ngDefaultControl>
                    </td>
                    <td></td>
                    <td></td>
                    <!-- <td></td> -->
                  </tr>
                </thead>
                <!-- *ngIf="(isPresentInACollection(scenario.tID)||!(attributeSelected.length>0))&&
                (isPresentInPCollection(scenario.persona)||!(personaSelected.length>0))&&
                (isPresentInCrCollection(scenario)||!(crSelected.length>0))&&
                (showScenario(scenario))" -->
                <tbody class="scenario-table executor-scenarios-table-body-height overflowAuto" ui-sortable
                  [(ngModel)]="modelData.scenarios" ngDefaultControl>
                  <tr class="row strict border-bottom1px clickable-row ui-sortable-item cursorPointer"
                    *ngFor="let scenario of modelData.scenarios|entitytestscenariofilter:selectedEntityeID:levelSelected:attributeSelected:crSelected:filterTypeList;">
                    <td class="col-xs-2 col-sm-1 no-padding border-left1px">
                      {{scenario.attribute.level}}
                    </td>
                    <td class="col-xs-2 col-sm-1 no-padding border-left1px">
                      {{scenario.attribute.symbol}}
                    </td>
                    <td class="col-xs-2 col-sm-1 no-padding border-left1px">
                      {{scenario.cr}}
                    </td>
                    <td class="col-xs-4 col-sm-7 border-left1px" (click)="editScenarioData(scenario)">
                      {{scenario.description}}
                    </td>
                    <td style="text-align: center;" class=" col-xs-2 col-sm-1 no-padding border-left1px">
                      <fa-icon *ngIf="getStatus(scenario.scenID)=='N'" (click)="updateStatus(scenario.scenID,'Y')"
                        class="far" [icon]="faCircle">
                      </fa-icon>
                      <fa-icon *ngIf="getStatus(scenario.scenID)=='Y'" (click)="updateStatus(scenario.scenID,'N')"
                        class="far" [icon]="faCheckCircle">
                      </fa-icon>
                    </td>
                    <td class=" col-xs-2 col-sm-1 no-padding border-left1px border-right1px">
                      <div style="text-align: center;">
                        <fa-icon *ngIf="getOutcome(scenario.scenID)==undefined||getOutcome(scenario.scenID)=='P'"
                          (click)="(!build||getStatus(scenario.scenID)=='Y') && updateOutcome(scenario.scenID,'F')"
                          class="fas green" style="color: lightgreen !important" [icon]="faThumbsUp"></fa-icon>
                        <fa-icon *ngIf="getOutcome(scenario.scenID)=='F'"
                          (click)="(!build||getStatus(scenario.scenID)=='Y') && updateOutcome(scenario.scenID,'P')"
                          style="color: red !important" class="fas red" [icon]="faThumbsDown"></fa-icon>
                      </div>
                    </td>
                    <!-- <td class=" col-xs-2 col-sm-1 no-padding border-left1px border-right1px"> -->
                    <!-- <div style="text-align: center;">
                        <fa-icon class="far" [icon]="faInfoCircle" title="help"
                          [ngClass]="{ dis: (!build||getOutcome(scenario.scenID)=='P'||!modelData.jiraProjectDetails.key)}"
                          data-toggle="modal" data-target="#jiraBugCreateModel">
                        </fa-icon>
                      </div> -->
                    <!-- </td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div ng-attr-id="validatorDesignCasesTab" *ngIf="currentView == 'design'" class="tab-pane fade in active h-100">
          <!-- <p>Design cases</p> -->
          <div id="executorQuillCSS" class="test-designer-quill-content-height">
            <quill-editor (onEditorChanged)="editorChanged($event)" (onBlur)="blur($event)"
              [(ngModel)]="selectedEntityNotes.notes">
              <div quill-editor-toolbar>
                <span class="ql-formats">
                  <select class="ql-header"></select>
                  <button class="ql-bold" [title]="'Bold'"></button>
                  <button class="ql-italic" [title]="'Italic'"></button>
                  <button class="ql-underline" [title]="'Underline'"></button>
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                  <!-- <button class="ql-image" [title]="'Image'"></button>
                  <button class="ql-code" [title]="'Code'"></button> -->
                </span>
              </div>
            </quill-editor>
          </div>
          <div>
            <!-- add button dropdown section -->
            <div class="row full-width pl-4 pr-4">
              <div class="col-xs-4 col-sm-7 col-md-8 col-lg-9 col-xl-9 pr-2" style="width: 70%;">
              </div>
              <div class="col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 pl-2 pr-2" style="width: 21%;">

                <div class="dropdown up">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">

                    <div class="row strict">
                      <div class="col-xs-10">
                        <span>{{selectedEditorAttribute.name}}
                        </span>
                      </div>
                      <div class="col-xs-1 col-xs-offset-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu up testDesignerEntityDropdown cursorPointer">
                    <li class="row strict" *ngFor="let Attr of config.listofFunctionalityTestTypes">
                      <div class="col-xs-11 col-xs-offset-1  dropdown-item" (click)="selectedAttribute(Attr)">
                        {{Attr.name}}
                      </div>
                    </li>
                    <li class="row strict" *ngFor="let Attr of config.listOfAttributesUpdated">
                      <div class="col-xs-11 col-xs-offset-1  dropdown-item" (click)="selectedAttribute(Attr)">
                        {{Attr.name}}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-2 col-sm-1 col-xl-1 col-lg-1 col-md-1 pr-2 pl-0">
                <button type="button" (click)="checkQuillSelection()"
                  class="btn btn-default btn-block btn-sm float-right paddingtop3px paddingbottom3px">
                  <!-- <i class="fa fa-plus menuItemsClrBlack"></i> -->
                  <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div ng-attr-id="validatorSpecsTab" *ngIf="currentView == 'specs'" class="tab-pane fade in active h-100">
          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white executorPopover">
                <legend class="scheduler-border cursorArrow">{{'deepDive.ddBcHeader'| translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddBcHeaderTip'| translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="BC" rows="1" class=" form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntityDetails.bc" [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddBcHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white executorPopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddAcHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddAcHeaderTip'| translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="AC" rows="1" class="form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntityDetails.ac" [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddAcHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white executorPopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddOutcomeHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddOutcomeHeaderTip'| translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="outcomes" rows="1"
                        class=" form-control transparent square-edge bg-color-black h-100" [(ngModel)]="selectedEntityDetails.outcomes"
                        [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddOutcomeHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white executorPopover">
                <legend class="scheduler-border cursorArrow">{{'deepDive.ddPiHeader'| translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddPiHeaderTip'| translate ">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="pi" rows="1" class=" form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntityDetails.pIssues" [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddPiHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="executorTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'validator.tip1' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'validator.tip2' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'validator.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#executorTip" data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#executorTip" data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- The plane name selection modal to generate exucutor report -->
  <div class="modal fade" id="validatorPlanSelectionPopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9 margintop8px">
                <div class="form-element mt-0 dropdown">
                  <label class="form-label displayNone">{{'taskPlanner.choosePlanHeading' | translate}}</label>
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-10 span-on-button ">
                        <span *ngIf="planNamesArray.length > 0">{{plannerName || 'taskPlanner.choosePlanHeading' |
                          translate }}</span>
                        <span *ngIf="planNamesArray.length <= 0">{{plannerName || 'taskPlanner.addPlanHeading' |
                          translate }}</span>
                      </div>
                      <div class="col-xs-1 col-xs-offset-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu planNameSelectionDropdown">
                    <li (click)="selectedPlannameToLS(task.plan_name)" *ngFor="let task of planNamesArray">
                      <a>{{task.plan_name}}</a>
                    </li>
                    <li *ngIf="planNamesArray.length <= 0">
                      <div class="col-xs-12 alert mb-0 p-0">
                        <strong>{{ 'taskPlanner.emptyPlannameList' | translate }}</strong>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3 margintop8px">
                <div class="form-element">
                  <label class="form-label displayNone">&nbsp;</label>
                  <div class="form-element-input ml-2">
                    <button type="button" data-dismiss="modal"
                      class="btn btn-sm btn-secondary userInvitetoOrgBtn actionbutton mt-0 mb-0 paddingtop4px paddingbottom4px"
                      (click)="generateReport('true')">Ok</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The Scenario delete Confirm Message Modal -->
  <div class="modal fade" id="deleteScenarioConfirmPopupModelValidator" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <!-- <div class="form-element text-align-center">
                        <label class="form-label marginbottom6px contentEllipsis text-align-center"
                          title={{landscape.entityModel.duplicateEntity}}>{{landscape.entityModel.duplicateEntity}}</label>
                      </div> -->
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">{{message}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
              (click)="deleteScenarioByEdit();resetExRowColorOnFilter()">{{ 'yes' | translate }}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'no' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The empty scenario add error popup modal -->
  <div class="modal fade" id="emptyScenAddErrorPopupValidator" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">Scenario can't be empty</label>
                  <!-- <label class="form-label marginbottom6px">{{testDesigner.controller.emptyScenErrMsg}}</label> -->
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <!-- <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                    (click)="openMenu('switch');closeNav()">Yes</button> -->
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The scenario duplicate error message modal -->
  <div class="modal fade" id="duplicateScenarioErrorPopupModelDesigner" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{duplicateScenario}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{errorMessage}}</label>
                </div>
                <div class="form-element text-align-center">
                  <button type="button" class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0"
                    data-dismiss="modal">{{ 'ok' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkTE" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkTE" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.testexecutor' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="ExVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- The change password form modal -->
  <div class="modal fade" id="jiraBugCreateModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <form novalidate method="post" class="form-group" (ngSubmit)="createJiraBug()">
                  <div class="form-header title text-align-center text-color-black">
                    {{ 'jira.jiraBugTitle' | translate }}
                  </div>
                  <div class="form-element mb-0">
                    <div class="form-element-input">
                      <input type="text" class="form-input-feild text-color-black" [(ngModel)]="jiraBugDetails.summary"
                        [ngModelOptions]="{standalone: true}" [placeholder]="'jira.jiraBugSummary'| translate"
                        ngDefaultControl required>
                    </div>
                  </div>
                  <div class="form-element mb-0">
                    <div class="form-element-input">
                      <textarea type="text" class="form-input-feild text-color-black"
                        [(ngModel)]="jiraBugDetails.description" [ngModelOptions]="{standalone: true}"
                        [placeholder]="'jira.jiraBugDesc'| translate" ngDefaultControl required>
                      </textarea>
                    </div>
                  </div>
                  <div id="jiraBugMessage">
                    <div class="text-message text-color-black">
                      {{toastMsg}}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" (click)="createJiraBug()">
              {{ 'jira.jiraBugCreate' | translate }}
            </button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'jira.cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>